import Input from '@guestyci/foundation/Input';
import FormField from '@guestyci/foundation/FormField';
import createStyles from '@guestyci/foundation/createStyles';
import defaultTheme from '@guestyci/foundation/theme/defaultTheme';

const useStyles = createStyles((theme: typeof defaultTheme) => ({
  input: {
    '& input': {
      fontSize: '1rem',
      /* Remove Chrome autofill highlight */
      [`&:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus,
      &:-webkit-autofill:active`]: {
        '-webkit-box-shadow': '0 0 0 30px white inset !important',
      },
      '&::placeholder': {
        fontSize: '1rem',
      },
    },
    borderRadius: '30px',
    overflow: 'hidden',
    borderWidth: 2,
    borderColor: '#e0e0e0',
    height: 60,
  },
  root: {
    '& div[class*=label]': {
      color: theme.palette.text.dark,
      fontSize: '18px',
      fontWeight: 600,
    },
  },
}));

interface InputFieldProps {
  label: string;
  name: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  type?: string;
}

export default function InputField({
  label,
  name,
  placeholder,
  disabled,
  required = false,
  type = 'text',
}: InputFieldProps) {
  const classes = useStyles();

  return (
    <FormField
      label={label}
      name={name}
      required={required}
      className={classes.root}
    >
      <Input
        // @ts-ignore
        type={type}
        disabled={disabled}
        placeholder={placeholder}
        className={classes.input}
      />
    </FormField>
  );
}
